import CheckboxOptionElement from './checkbox-option-element';

const MAX_INTEGER = 1.7976931348623157e308;

export enum CheckboxGroupState {
  Checked = 'checked',
  Unchecked = 'unchecked',
}

export default class CheckboxGroupElement extends HTMLElement {
  checkedOptions = new Set();

  connectedCallback() {
    this.addEventListener('checkbox-option:checked', this.onChecked);
    this.addEventListener('checkbox-option:unchecked', this.onUnchecked);
  }

  disconnectedCallback() {
    this.removeEventListener('checkbox-option:checked', this.onChecked);
    this.removeEventListener('checkbox-option:unchecked', this.onUnchecked);
  }

  onChecked(event: Event) {
    const element = event.target;
    if (!(element instanceof CheckboxOptionElement)) return;

    if (this.checkedOptions.size >= this.maxChecked) {
      element.checked = false;
      return;
    }

    this.checkedOptions.add(element.value);
    dispatch(this, element, CheckboxGroupState.Checked);
  }

  onUnchecked(event: Event) {
    const element = event.target;
    if (!(element instanceof CheckboxOptionElement)) return;

    if (this.checkedOptions.size <= this.minChecked) {
      element.checked = true;
      return;
    }

    this.checkedOptions.delete(element.value);
    dispatch(this, element, CheckboxGroupState.Unchecked);
  }

  get minChecked() {
    return Number(this.getAttribute('min'));
  }

  get maxChecked() {
    if (!this.hasAttribute('max')) return MAX_INTEGER;

    return Number(this.getAttribute('max'));
  }
}

function dispatch(element: HTMLElement, relatedTarget: CheckboxOptionElement, type: CheckboxGroupState) {
  element.dispatchEvent(
    new CustomEvent('checkbox-group:change', {
      detail: { relatedTarget, type },
      bubbles: true,
    })
  );
}
